<template>
  <TableColumnPrimary v-bind="attrs"
                      v-on="$listeners"
                      :header="header"
                      :rows="rows"
                      :width="width">
    <template v-slot:row="props">
      <slot name="row"
            :index="props.index"
            :row="props.row">
        <div :style="innerRowContainerStyle">
          <div :style="imageContainerStyle">
            <UserImage :src="props.row.user.image"
                       :style="imageStyle"
                       :tenantUserId="props.row.id" />
          </div>
          <div :style="userProfileContainerStyle">
            <div :style="userNameContainerStyle">
              <HybridLinkNamePrimary :isRouterLink="false"
                                     :style="userNameStyle"
                                     :tenantUserId="props.row.id"
                                     :truncate="truncate">
                {{ props.row.user.firstName }} {{ props.row.user.lastName }}
              </HybridLinkNamePrimary>
            </div>
            <div :style="userEmailContainerStyle">
              {{ props.row.user.email }}
            </div>
          </div>
        </div>
      </slot>
    </template>
  </TableColumnPrimary>
</template>

<script>
  import HybridLinkNamePrimary from '@modules/link/hybrid-link-name-primary'
  import TableColumnPrimary from '@modules/table/table-column-primary'
  import UserImage from '@modules/image/user-image'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TableUserColumnPrimary',
    inheritAttrs: false,
    components: {
      HybridLinkNamePrimary,
      TableColumnPrimary,
      UserImage,
    },
    props: {
      header: { type: String, required: false, default: '' },
      rows: { type: Array, required: false, default: () => [] },
      truncate: { type: Boolean, required: false, default: false },
      width: { type: String, required: false, default: '100%' },
    },
    data: function () {
      return {
        attrs: {
          backgroundColor: 'transparent',
        },
        imageContainerStyle: {
          height: '32px',
          margin: `0 ${Layout.space.sm} 0 0`,
          width: '32px',
        },
        imageStyle: {
          height: '32px',
          width: '32px',
        },
        innerRowContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          justifyContent: 'flex-start',
        },
        truncateStyle: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        userEmailContainerStyle: {
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.md,
          lineHeight: FontStyle.size.sm,
        },
        userNameContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          lineHeight: `${parseInt(FontStyle.size.md) + 2}px`,
        },
        userNameStyle: {
          display: 'block',
        },
        userProfileContainerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '36px',
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        ...this.$attrs,
      };

      this.userEmailContainerStyle = {
        ...this.userEmailContainerStyle,
        color: this.color.dark2(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
